import { useDispatch } from "react-redux";
import { fetchCashbackStart } from "store/transactions/cashback/action";
import { useState } from "react";
import { debounce } from "lodash";
import SearchBar from "components/Common/SearchBar";
import CashbackAdvancedFilter from "./CashbackAdvancedFilter";
import CashbackDownloadFileType from "../CashbackDownloadFileType";


export default function CashbackFilter(props) {
  const dispatch = useDispatch();
  const handleSearchInput = debounce((event) => {
    let payload = {};
    if (event.target.value)  {
      payload.searchText = event.target.value;
      props.setSelectedValues(prev => ({ 
        ...prev, 
        ...payload 
      }));
    } else { 
      props.setSelectedValues(prev => { 
        const oldValues = {...prev};
        delete oldValues.searchText;
        return oldValues;
      });
    }
    dispatch(fetchCashbackStart(payload));
  }, 500);
  const initFilteredValues = {
    clientId: "",
    dateFrom: "",
    dateTo: "",
    agent: "",
  };
  const [filteredValues, setFilteredValues] = useState(initFilteredValues);
  const filterChangeHandler = (filteredValuesData) => {
    setFilteredValues(filteredValuesData);
    let payload = {};
    const dataKeys = Object.keys(filteredValuesData);
    dataKeys.forEach((key) => {
      if (filteredValuesData[key]) {
        payload[key] = filteredValuesData[key];
      }
    });
    // selectedValues(prev => ({
    //   ...prev,
    //   ...payload
    // }));
    dispatch(fetchCashbackStart(payload));
  };
  return <div>
    <div className="d-flex flex-row align-items-center">
      <SearchBar
        handleSearchInput={handleSearchInput}
        placeholder={props.t("Search by client name")}
      />
      <CashbackAdvancedFilter
        setSelectedValues={props.setSelectedValues}
        filterChangeHandler={filterChangeHandler}
        filteredValues={filteredValues}
      />
    </div>
    <div className="d-flex justify-content-end" >
      <CashbackDownloadFileType selectedValues={props.selectedValues} />
    </div>
  </div>;
}   